import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../store';
import Layout from '../Layout/Layout';
import { actionCreators } from "../../store/LabEquipment";
import { Row } from 'reactstrap';
import "./utils/LabEquipment.css";
import labEquipmentDataPreparator from './utils/labEquipmentDataPreparator';
import EquipmentList from './EquipmentList';
import EquipmentRegistrationModal from './EquipmentRegistrationModal';

const SERA_Q_TEST_GROUP_FILTER = "Serology";

const Serology = () => {
    const dispatch = useDispatch();
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        dispatch(actionCreators.fetchLabEquipment());
    }, [dispatch]);

    const seraQEquipment = useSelector((state: ApplicationState) =>
        state.labEquipment ? labEquipmentDataPreparator(state.labEquipment, SERA_Q_TEST_GROUP_FILTER) : {}
    );

    const openRegistrationModal = () => {
        setModalOpen(true);
    }

    return (
        <Layout>
            <Row className="cards-wrapper">
                <EquipmentList equipment={seraQEquipment} onSuccessfulStatusUpdate={() => {
                            dispatch(actionCreators.fetchLabEquipment());
                        }} />
            </Row>
            <Row>
                <input
                    className="w-20 btn btn-primary btn-lg"
                    value="Add equipment"
                    onClick={openRegistrationModal}
                />
                {modalOpen &&
                    <EquipmentRegistrationModal
                        testGroup={SERA_Q_TEST_GROUP_FILTER}
                        isOpen={modalOpen}
                        toggle={() => setModalOpen(false)}
                        onSuccessfulRegistration={() => {
                            dispatch(actionCreators.fetchLabEquipment());
                        }} />
                }
            </Row>
        </Layout>
    );
};

export default Serology;
